import { render, staticRenderFns } from "./SideNavBar.vue?vue&type=template&id=986875d0&scoped=true&"
import script from "./SideNavBar.vue?vue&type=script&lang=js&"
export * from "./SideNavBar.vue?vue&type=script&lang=js&"
import style0 from "./SideNavBar.vue?vue&type=style&index=0&id=986875d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986875d0",
  null
  
)

export default component.exports